module.exports = __webpack_public_path__ + "static/media/svg-2.0f4ad5d5.svg";